import { ConfigProvider } from "antd";
import jaJP from "antd/locale/ja_JP";
import { BrowserRouter } from "react-router-dom";

import { AppRoutes } from "./app/router/AppRoutes";
import { AuthProvider } from "./features/auth/model/AuthContext";

function App() {
  return (
    <ConfigProvider locale={jaJP} theme={{ token: { colorPrimary: "#1677ff" } }}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
